'use client';

import React from 'react';
import { thirdPartyScriptRegistry } from './third-party-script.registry';
import { ThirdPartyScriptDefinition } from './types';
import { useThirdPartyScriptsConfig } from './use-third-party-scripts-config';
interface Props {
  placement: ThirdPartyScriptDefinition['placement'];
}
const ThirdPartyScripts = ({
  placement
}: Props) => {
  const {
    data
  } = useThirdPartyScriptsConfig();
  if (!data) return null;
  return <>
            {Object.entries(thirdPartyScriptRegistry).filter(([, script]) => script.placement === placement).map(([name, script]) => {
      return <React.Fragment key={name}>{script.render(data)}</React.Fragment>;
    })}
        </>;
};
export default ThirdPartyScripts;